import * as requestFromServer from "./packagesApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";

// packages -> get packages api
export const getPackagesAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getPackages(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_PACKAGES_LIST, {packages:response}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// services -> create services api
export const createPackageAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createPackage(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      navigate(baseRouteMaker(routes.PACKAGES));
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// packages -> update packages api
export const updatePackageAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updatePackage(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      navigate(baseRouteMaker(routes.PACKAGES));
      return response;
    } else {
      setLoading(false);
      return null;
    }
};

// services -> get service by id api
export const getPackageByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getPackageById(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_PACKAGE_BY_ID,{package:response}))
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
};

// package -> delete package by id api
export const deletePackageByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.deletePackageById(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
};
